import { Link } from '@chakra-ui/react';

import { usBankSlug } from '../../../constants/lienholders';

const SpecialInstructions = ({ lienholderSlug }: { lienholderSlug: string }) => (
  <>
    {lienholderSlug === usBankSlug && (
      <>
        Call{' '}
        <Link
          color="royalBlue"
          _hover={{ color: 'royalBlueDark' }}
          href="tel: 866-250-3147"
          mr="2"
          _last={{ mr: 0 }}
        >
          866-250-3147
        </Link>{' '}
        for your payoff quote and good-through date if you have less than 12 months left, or{' '}
        <Link
          color="royalBlue"
          _hover={{ color: 'royalBlueDark' }}
          href="tel: 800-872-2657"
          mr="2"
          _last={{ mr: 0 }}
        >
          800-872-2657
        </Link>{' '}
        if you have more than 12 months remaining.
      </>
    )}
  </>
);

export default SpecialInstructions;
